<template>
    <section>
        <z-accordion :set-hash="false">
            <z-accordion-item id="acc-1">
                <template #header>
                    {{ formTextLocalize.title }}
                </template>
                
                <template #body>
                    <industrial-tourism-form :form-text-localize="formTextLocalize"></industrial-tourism-form>
                </template>
            </z-accordion-item>
        </z-accordion>
    </section>
</template>

<script setup>
import { formTextLocalize } from './composable/useLocalize';
import { IndustrialTourismForm } from './components/IndustrialTourismForm';

</script>

<style lang="scss">

</style>